document.getElementById("footer-subscribe-form").addEventListener("submit", function(event) {
    event.preventDefault();
    var formData = new FormData(event.target);
    var data = {};
    for (var [key, value] of formData.entries()) {
      data[key] = value;
    }
    fetch("https://krw-klav.herokuapp.com/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      if (response.status === 200) {
        //console.log'Thanks for subscribing');
  
        $('#footer-subscribe-form #k_id_email_footer').val('');
        
        $('#footer-subscribe-form').addClass('footer-signup-success');
        $("#footer-subscribe-form #k_id_email_footer").attr("placeholder","YOU'RE IN");
        $('#footer-subscribe-form #k_id_email_footer').blur();
  
  
      } else {
          $('#footer-subscribe-form #k_id_email_footer').val('Invalid email');
          setTiemout(function() {
          $('#footer-subscribe-form #k_id_email_footer').val('');
          }, 3000);
      }
    })
    .catch(error => {
     //console.log'Error subscribing: '+ error);
    });
  });
  